module.exports = __webpack_public_path__ + "bcfd1f04ac25b999dccf59c995595560.svg";